import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "about" */ '../components/share.vue')
  }
  // {
  //   path: '/abc',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/abc.vue')
  // }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/route.js